import React from 'react';
import Moment from 'moment';

import Link from 'utils/localized-link';
import Button from '@youship/components/objects/button';
import Banner from 'components/sections/banner';
import Layout from 'components/layout';
import BasicLayout from 'components/basic-layout';
import SEO from 'components/seo';
import Image from 'components/image';

import barraImage from '../../images/barra-centro2030.png';

import followImage from '../../images/projects/follow-me.png';


const bannerImage = 'home/robot-banner-bottom2.jpg';

const bannerButtons = [
  {
    linkComponent: Link,
    linkProps: {
      to: '/contacts'
    },
    light: true,
    noArrow: true,
    small: true,
    text: 'expertise.banner.buttons.contacts'
  }
];

const ProjectPage = ({ pageContext: { locale } }) => (

  <Layout locale={locale}>
    <SEO title="Follow & Deliver" />
    <BasicLayout>
    <>
        <div className="">
            <img
                    alt="Centro 2030"
                    src={barraImage}
                />
        </div>  
        <div>
            <p className="b-layout__center">
            <h3>Follow & Deliver</h3>
            YOUSHIP, UNIPESSOAL LDA 
            <br/>
            <span className='b-layout__xs'>Santo António dos Olivais - Coimbra - Coimbra</span>
            </p>
        </div>
        
        <div style={{paddingBottom: '0px'}}>
            <p>
            A operação "Follow & Deliver" visa desenvolver um robô móvel autónomo de logística, capaz de seguir um distribuidor ou navegar autonomamente em ambientes urbanos e interiores. O objetivo é criar um robô que transporte pequenas e médias encomendas, abordando os custos laborais e a escassez de mão de obra no setor das entregas. Espera-se obter um robô eficiente e seguro, utilizando sensores de baixo custo, visão computacional e machine learning. Os resultados incluem a criação de modelos de deteção e algoritmos de navegação autónoma, integrando modos "follow-me" e navegação autónoma na mesma plataforma.
            </p>
            <p align="center" style={{paddingTop: '40px', lineHeight: '0'}}>
             <img
                    alt="Follow"
                    src={followImage}
                    style={{maxWidth: '500px'}}
                />
            </p>
        </div>

        <div>
            <div class="row b-layout__content__item">
                <div class="col">
                    <p>
                        Investimento Total: 373.608,00 €
                        <br/>
                        Apoio Financeiro da União Europeia: 290.365,52 €
                    </p>
                </div>
                <div class="col">
                    <p>
                        <a href="/projects/Ficha-de-Operacao.pdf">Ficha da Operação</a>
                    </p>
                </div>
            </div>
        </div>
    </>
    </BasicLayout>
    <Banner
      buttons={bannerButtons}
      image={bannerImage}
      title="home.banner.title"
    />

  </Layout>
);

export default ProjectPage;
